module.exports = __webpack_public_path__ + "img/cropped-logotipo-bambi.57baaa75.png";